/* eslint-disable prettier/prettier */
import axios from 'axios'

const state = {
    suppliers: {},
    supplier: {},
    isLoadingTable: false,
    showDeleteModal: false
}

const mutations = {
    getPaginatedSuppliers(state, payload) {
        state.isLoadingTable = true
        axios.get(`api/suppliers/page=${payload.page}&pageSize=${payload.pageSize}/${payload.query}`).then(response => {
            state.suppliers = response.data
            // eslint-disable-next-line no-console
        }).catch(error => console.log(error)).then(() => state.isLoadingTable = false)
    },
    openDeleteModal(state, payload) {
        state.showDeleteModal = payload.showDeleteModal
        if (payload.supplier) {
            state.supplier = payload.supplier
        } else {
            state.supplier = {}
        }
    }
}

const actions = {
    getPaginatedSuppliers({
        commit
    }, payload) {
        commit('getPaginatedSuppliers', payload)
    },
    openDeleteModal({
        commit
    }, payload) {
        commit('openDeleteModal', payload)
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}